/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isEditionAuthorized, openEditInterviewModal }
) => (
  isEditionAuthorized &&      
  <OverlayTrigger
    overlay={<Tooltip id="interview-edit-tooltip">Düzenle</Tooltip>}
  >
    <a
      className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
      onClick={() => openEditInterviewModal(row.id)}
    >
      <span className="svg-icon svg-icon-md svg-icon-primary">
        <SVG
          src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
        />
      </span>
    </a>
  </OverlayTrigger>
);